import React, { useState } from 'react';

import { SERVICE_PROVIDER_CATEGORIES } from '../../config/serviceProviderCategories';
import { joinSupplyWaitlist } from '../../util/api';

import css from './SimpleAppExperience.module.css';

/**
 * Supply-side: “Notify me when a job matches” — no need for demand to exist first.
 */
const SupplyWaitlistForm = ({ kind = 'services', className }) => {
  const [contact, setContact] = useState('');
  const [categoryId, setCategoryId] = useState('all');
  const [area, setArea] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [status, setStatus] = useState(null); // idle | saving | ok | err
  const [error, setError] = useState('');

  const onSubmit = async e => {
    e.preventDefault();
    if (!contact.trim()) {
      setError('Add WhatsApp, Telegram, or email so we can reach you.');
      return;
    }
    setStatus('saving');
    setError('');
    try {
      await joinSupplyWaitlist({
        kind,
        contact: contact.trim(),
        categoryId: categoryId === 'all' ? null : categoryId,
        area: area.trim() || null,
        displayName: displayName.trim() || null,
        channel: contact.includes('@') && !contact.startsWith('+') ? 'email' : 'whatsapp',
      });
      setStatus('ok');
      setContact('');
    } catch (err) {
      setStatus('err');
      setError(err.message || 'Could not join waitlist');
    }
  };

  return (
    <section className={className} data-testid="supply-waitlist">
      <h2 className={css.sectionTitle}>Notify me when a job matches</h2>
      <p className={css.promise}>
        Supply without demand is fine — leave your contact and category. When a matching request is
        posted, ops gets an alert (Telegram) and can connect you.
      </p>
      {status === 'ok' ? (
        <p className={css.settlementStory}>You’re on the waitlist. We’ll ping ops when jobs match.</p>
      ) : (
        <form className={css.fields} onSubmit={onSubmit}>
          <label className={css.field}>
            <span className={css.fieldLabel}>Display name</span>
            <input
              className={css.input}
              value={displayName}
              onChange={e => setDisplayName(e.target.value)}
              placeholder="Your trade name"
            />
          </label>
          {kind === 'services' ? (
            <label className={css.field}>
              <span className={css.fieldLabel}>Category</span>
              <select
                className={css.input}
                value={categoryId}
                onChange={e => setCategoryId(e.target.value)}
              >
                <option value="all">Any category</option>
                {SERVICE_PROVIDER_CATEGORIES.map(c => (
                  <option key={c.id} value={c.id}>
                    {c.label}
                  </option>
                ))}
              </select>
            </label>
          ) : null}
          <label className={css.field}>
            <span className={css.fieldLabel}>Area</span>
            <input
              className={css.input}
              value={area}
              onChange={e => setArea(e.target.value)}
              placeholder="Kingston, Portmore, Online…"
            />
          </label>
          <label className={css.field}>
            <span className={css.fieldLabel}>Contact *</span>
            <input
              className={css.input}
              value={contact}
              onChange={e => setContact(e.target.value)}
              placeholder="WhatsApp number, @telegram, or email"
              required
            />
          </label>
          {error ? <p className={css.cardMeta}>{error}</p> : null}
          <div className={css.actionRow}>
            <button
              type="submit"
              className={css.primaryBtn}
              disabled={status === 'saving'}
              data-testid="supply-waitlist-submit"
            >
              {status === 'saving' ? 'Saving…' : 'Notify me'}
            </button>
          </div>
        </form>
      )}
    </section>
  );
};

export default SupplyWaitlistForm;
